import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { translate } from 'elc-service';
import { NumberSpinner } from 'elc-number-spinner';
import { Subtitle2 } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import { lazyInject, serviceNames } from '../../service-setup/diContainer';
import { ConfigStore } from '../../service-setup/ConfigStore';
import { classes } from '../../internal/utils/Classes';
import { CART_PRODUCT_QUANTITY } from '../../internal/constants/DataTestIdAttributes';

export interface IProductQuantitySelectorLabels {
    productQuantityLabel: string;
    decreaseProductQuantityLabel: string;
    increaseProductQuantityLabel: string;
}

export interface IProductQuantitySelector {
    onQuantitySelect?(val: number): void;
    translations?: IProductQuantitySelectorLabels;
    config: {
        maxQuantity?: number;
        skuId: string;
        currentQuantity: number;
    };
}

const QuantitySection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: ${ContentSpacing.space12};
    align-items: baseline;
    [dir='rtl'] & {
        margin-left: 0;
    }
`;

const QuantityLabel = styled(Subtitle2)`
    display: flex;
    align-items: center;
    margin-right: ${ContentSpacing.space12};
    [dir='rtl'] & {
        margin-right: 0;
        margin-left: ${ContentSpacing.space12};
    }
`;

@translate(['productQuantityLabel', 'increaseProductQuantityLabel', 'decreaseProductQuantityLabel'])
@observer
export class ProductQuantitySelector extends React.Component<IProductQuantitySelector> {
    @lazyInject(serviceNames.configStore) private configStore: ConfigStore;
    private productQuantitySelectorClassNames = classes('quantity-selector-button');
    private quantitySelectorLabelClassNames = classes('quantity-selector-label');
    private numberSpinnerClassNames = classes('item-quantity-spinner-selector');

    public render() {
        const {
            productQuantityLabel,
            decreaseProductQuantityLabel,
            increaseProductQuantityLabel
        } = this.props.translations as IProductQuantitySelectorLabels;
        const { config, onQuantitySelect } = this.props;
        const { maxQuantity, skuId, currentQuantity } = config;

        return (
            <QuantitySection className={this.productQuantitySelectorClassNames}>
                <QuantityLabel className={this.quantitySelectorLabelClassNames}>
                    {productQuantityLabel}
                </QuantityLabel>
                <NumberSpinner
                    defaultValue={currentQuantity}
                    minValue={1}
                    maxValue={maxQuantity}
                    aria-controls={`product-total-${skuId}`}
                    onChange={onQuantitySelect}
                    dataTestId={CART_PRODUCT_QUANTITY}
                    className={this.numberSpinnerClassNames}
                    decreaseQuantityAriaLabel={decreaseProductQuantityLabel}
                    increaseQuantityAriaLabel={increaseProductQuantityLabel}
                    {...this.configStore.config}
                />
            </QuantitySection>
        );
    }
}

export default ProductQuantitySelector;
